import { ExternalLink } from "lucide-react";
import { Badge } from "../../../../shared/components/badge/Badge";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const SectionTitleCell = ({ data }) => {
  const { t } = useTranslation();
  return (
    <div className="font-medium">
      <Link
        to={data.route}
        className="underline flex flex-row items-center gap-x-1"
        target={data.external ? "_blank" : ""}
      >
        {t(data.title)}
        {data.external && <ExternalLink className="w-3 h-3" />}
        {data.status.toUpperCase() !== "STABLE" && (
          <Badge variant="outline" className="ml-1">
            {t(`defaults.itemStatus.${data.status.toLowerCase()}`)}
          </Badge>
        )}
      </Link>
    </div>
  );
};

export default SectionTitleCell;
